<template>
  <div class="proposal-documents">
    <validation-observer ref="proposalDocuments">
      <amendment-document
        v-show="visibleAmendment"
        :amendment-document="amendmentDocument"
        @on-upload-file="uploadDocumentHandler"
      />
    </validation-observer>
    <section-title
      class="mt-4 mb-3"
      has-line
      title="Documentos Propuesta"
      title-class="section-title-info"
    />
    <div
      v-for="(document, idx) of page.data"
      :key="idx"
      class="proposal-documents__element"
    >
      <document-info
        :add-file="canEditDocuments"
        :document="document"
        :file-preview="!canEditDocuments"
        show-filename
        @on-upload-file="onUploadFile($event, document)"
      />
    </div>
    <pagination
      v-if="page.totalItemCount > pageSize"
      :data="page"
      :page-size="pageSize"
      @pagination-go-page="setCurrentPage"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Pagination from 'pagination';
import DocumentInfo from '@/views/provider/proposalHistory/components/DocumentInfo.vue';
import AmendmentDocument from '@/views/provider/proposalHistory/components/AmendmentDocument.vue';
import SectionTitle from 'SectionTitle';
import {
  getProposalEvaluationDocuments,
  submitProposalAmendmentDocument,
  getAmendmentDocument,
  uploadContractDocument,
} from '@/modules/serviceProposalHistory/api';
import alertMixin from 'utils/mixins/alert.mixin.js';
import { serialize as objectToFormData } from 'object-to-formdata';
import documentTypes from '@/utils/shared/constants/documentTypes';
import proposalDocumentTypes from '@/utils/constants/proposalDocumentTypes';

export default {
  name: 'ProposalDocumentsTab',
  components: {
    DocumentInfo,
    Pagination,
    SectionTitle,
    AmendmentDocument,
  },
  mixins: [alertMixin],
  props: {
    proposalRequestId: {
      type: Number,
      default: () => 0,
    },
    bus: {
      type: Vue,
      default: () => new Vue(),
    },
    canSubmitAmendmnet: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    page: {
      totalItemCount: 0,
      count: 0,
      pageCount: 0,
      currentPage: 1,
      data: [],
    },
    pageSize: 10,
    amendmentDocument: {},
    file: null,
  }),
  computed: {
    visibleAmendment() {
      return (
        this.canSubmitAmendmnet || this.amendmentDocument.documentId != null
      );
    },
    canEditDocuments() {
      return this.userHasPermissions('proposal.changedocuments');
    },
  },
  async created() {
    await this.getAmendmentDocument();
    await this.setCurrentPage(1);
    this.bus.$on('submitAmendmentDocument', async () => {
      await this.saveAmendmentDocument();
    });
  },
  methods: {
    async onUploadFile(file, document) {
      const params = objectToFormData(
        {
          proposalRequestId: document.proposalRequestId,
          documentId: document.documentId,
          DocumentTypeId: document.documentTypeId,
          proposalDocumentTypeId: document.proposalDocumentTypeId,
          file,
        },
        { indices: true, nullsAsUndefineds: true }
      );
      await uploadContractDocument(params)
        .then(() => {
          this.ShowToast(
            'Alerta',
            'El archivo fue guardado exitosamente',
            'success'
          );
        })
        .catch((err) => {
          if (err.response != null)
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    async getAmendmentDocument() {
      await getAmendmentDocument(this.proposalRequestId).then((res) => {
        this.amendmentDocument = res.data;
      });
    },
    uploadDocumentHandler(document) {
      this.file = document;
    },
    async saveAmendmentDocument() {
      const isValid = await this.$refs.proposalDocuments.validate();
      if (!isValid) {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información  solicitada para poder continuar.',
          'error'
        );
        return;
      }
      const params = objectToFormData(
        {
          proposalRequestId: this.proposalRequestId,
          proposalDocumentTypeId: proposalDocumentTypes.AmendmentDocument,
          DocumentTypeId: documentTypes.AmendmentDocument,
          file: this.file,
        },
        { indices: true, nullsAsUndefineds: true }
      );
      await submitProposalAmendmentDocument(params)
        .then(async () => {
          this.ShowToast(
            'Proceso Exitoso',
            'La solicitud ha sido cambiada de estatus exitosamente.',
            'success'
          );
          await this.getAmendmentDocument();
          this.$emit('on-proposal-status-change');
        })
        .catch((err) => {
          if (err.response != null)
            this.ShowToast(
              'Alerta',
              err.response.data.message || 'error',
              'error',
              5000
            );
        });
    },
    async setCurrentPage(pageNumber) {
      this.page.currentPage = pageNumber;
      await this.searchDocuments();
    },
    async searchDocuments() {
      const params = {
        pageIndex: this.page.currentPage,
        pageSize: this.pageSize,
      };
      await getProposalEvaluationDocuments(this.proposalRequestId, params).then(
        (res) => {
          const documents = res.data;
          this.page = {
            count: documents.count,
            totalItemCount: documents.totalItemCount,
            pageCount: documents.pageCount,
            data: documents.data,
            currentPage: documents.currentPage,
          };
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/shared/scss/config/colors.scss';

.proposal-documents {
  ::v-deep &__element {
    .document-info {
      background-color: map-get($colors, 'secondary-3');
      margin-bottom: 2rem;
    }
  }
}
</style>
